<template>
  <div>
    <div class="p-main-content">
      <div class="mtop">
      </div>
      <div class="main-text">
        <div class="text">
          <div class="title">
            <h1>￥{{ totalAmount }}</h1>
            <hr>
            <ul class="tstype">
              <el-popover popper-class="deliveryPopover" ref="downloadPopover" placement="bottom" width="90"
                trigger="hover" content="数据生产完成会存放在账户首页->我的云盘中。">
              </el-popover>
              <el-popover popper-class="deliveryPopover" ref="ftpPopover" placement="bottom" width="150" trigger="hover"
                content="数据生产完成会推送到您指定的FTP上。">
              </el-popover>
              <el-popover popper-class="deliveryPopover" ref="receiverPopover" placement="bottom" width="150"
                trigger="hover" content="数据会下载到您指定的服务器上。">
              </el-popover>
              <el-popover popper-class="deliveryPopover" ref="deadLinePopover" placement="bottom" width="150"
                trigger="hover" content="数据生产完成会通过快递邮寄到您指定的地址。">
              </el-popover>
              <li :class="sendtype[0].active" v-popover:downloadPopover @click="sendtypeclick(0)"><i
                  class="download"></i><span>下载</span></li>
              <li><span class="sx"></span></li>
              <li v-popover:ftpPopover :class="sendtype[1].active" @click="sendtypeclick(1)"><i
                  class="ftp"></i><span>推送</span></li>
              <ftp-list :ftpDialogvisible="ftpDialogvisible" :ftpList="ftpList" v-on:getFtpId="getFtpId"
                v-on:commitOrder="commitOrder" v-on:onDialogvisible="onDialogvisible">
              </ftp-list>
              <li v-if="accountType === '001'"><span class="sx"></span></li>
              <li v-if="accountType === '001'" v-popover:receiverPopover :class="sendtype[3].active"
                @click="sendtypeclick(3)"><i class="ftp"></i><span>接收</span></li>
              <server-list v-if="accountType === '001'" :serverDialogvisible="serverDialogvisible"
                :serverList="serverList" v-on:getServerId="getServerId" v-on:commitOrder="commitOrder"
                v-on:onServerDialogvisible="onServerDialogvisible">
              </server-list>
              <li><span class="sx"></span></li>
              <li v-popover:deadLinePopover :class="sendtype[2].active" @click="sendtypeclick(2)"><i
                  class="lxxz"></i><span>离线邮寄</span></li>
              <address-list :addressDialogvisible="addressDialogvisible" :addressList="addressList"
                v-on:getAddressId="getAddressId" v-on:commitOrder="commitOrder"
                v-on:onAddressDialogvisible="onAddressDialogvisible">
              </address-list>
            </ul>
            <div class="tobuy">
              <span class="buy" @click="orderCommit"><a>提交订单</a></span>
              <span class="buy">
                <router-link to="/remoteSenseData">朕再想想</router-link>
              </span>
            </div>
          </div>
          <el-table :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)" stripe class="tablelist">
            <el-table-column prop="product_name" label="产品名称" width="530">
              <!-- <template slot-scope="scope">
                <a href="#">{{ scope.row.orderid }}</a>
              </template> -->
            </el-table-column>
            <el-table-column prop="queryType" label="查询类型" width="230">
            </el-table-column>
            <el-table-column prop="area" label="面积（km²）" width="190">
            </el-table-column>
            <el-table-column prop="amountOfPay" label="金额（元）" width="150">
            </el-table-column>
          </el-table>
          <div class="pages" v-show="total > pageSize">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page.sync="currentPage" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize"
              layout="total, prev, pager, next" background :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FtpList from '../components/account/FtpList'
import ServerList from '../components/account/ServerList'
import AddressList from '../components/account/PostAddressList'
export default {
  name: 'payDetail',
  components: {
    FtpList,
    ServerList,
    AddressList
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 5,
      totalAmount: 0,
      total: 0,
      tableData: [],
      sendtype: [{
        type: 0,
        active: 'active'
      },
      {
        type: 1,
        active: ''
      },
      {
        type: 2,
        active: ''
      },
      {
        type: 3,
        active: ''
      }
      ],
      accountType: '',
      ftpDialogvisible: false,
      ftpList: [],
      ftp_id: '',
      serverDialogvisible: false,
      serverList: [],
      server_id: '',
      addressDialogvisible: false,
      addressList: [],
      address_id: ''
    }
  },
  mounted () {
    // 取出选中的购物车项
    let cartInfo = JSON.parse(sessionStorage.getItem('cartInfo'))
    if (cartInfo) {
      let { selectedList, totalAmount } = cartInfo
      this.tableData = selectedList
      this.total = this.tableData.length
      this.totalAmount = totalAmount
    }
    // 取出用户信息
    let user = JSON.parse(sessionStorage.getItem('user'))
    this.accountType = user.accountType
  },
  destroyed () {
    sessionStorage.removeItem('cartInfo')
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      console.log(`当前页: ${val}`)
    },
    // 交付方式选择
    sendtypeclick (type) {
      // 操作数组
      this.sendtype.forEach(item => {
        // 选中样式
        if (item.type === type) {
          item.active = 'active'
        } else {
          item.active = ''
        }
      })
      // 推送
      if (type === 1) {
        // 弹出推送ftp对话框
        this.ftpDialogvisible = true
        // 查询推送地址信息
        this.sapost('/dmc/ftp/ftpList', '', r => {
          this.ftpList = r.data
        })
      } else {
        this.ftpDialogvisible = false
      }
      // 接收
      if (type === 3) {
        // 弹出接收ftp对话框
        this.serverDialogvisible = true
        // 查询推送地址信息
        this.sapost('/dmc/uploadServer/serverList', '', r => {
          this.serverList = r.data
        })
      } else {
        this.serverDialogvisible = false
      }
      // 离线邮寄
      if (type === 2) {
        // 弹出推送邮寄地址对话框
        this.addressDialogvisible = true
        // 查询邮寄地址信息
        this.sapost('/dmc/address/addressList', '', r => {
          this.addressList = r.data.addressList
        })
      } else {
        this.addressDialogvisible = false
      }
    },
    // 订单提交
    orderCommit () {
      var _this = this
      // 要提交的购物车id数组
      let shoppingCartItemId = []
      this.tableData.forEach(item => {
        shoppingCartItemId.push(item.shopping_cart_item_id)
      })
      // 选择的交付方式
      let deliveryType = this.sendtype.find(item => item.active === 'active')
      let data = {}
      // 下载
      if (deliveryType.type === 0) {
        data = {
          shopping_cart_item_id: shoppingCartItemId,
          delivery_type: deliveryType.type
        }
      }
      // 推送
      if (deliveryType.type === 1) {
        if (this.ftp_id === '') {
          this.$message.error('请选择推送地址！')
          return
        }
        data = {
          shopping_cart_item_id: shoppingCartItemId,
          delivery_type: deliveryType.type,
          ftp_id: this.ftp_id
        }
      }
      // 接收
      if (deliveryType.type === 3) {
        if (this.server_id === '') {
          this.$message.error('请选择接收地址！')
          return
        }
        data = {
          shopping_cart_item_id: shoppingCartItemId,
          delivery_type: deliveryType.type,
          server_id: this.server_id
        }
      }
      // 离线邮寄
      if (deliveryType.type === 2) {
        if (this.address_id === '') {
          this.$message.error('请选择邮寄地址！')
          return
        }
        data = {
          shopping_cart_item_id: shoppingCartItemId,
          delivery_type: deliveryType.type,
          address_id: this.address_id
        }
      }
      this.sapost('/dmc/order/orderCommit', data, r => {
        let result = r.data
        if (result.result_code === 'SUCCESS') {
          console.log(_this.$router)
          _this.$router.push({
            path: '/order/orderPay',
            query: {
              id: result.id
            }
          })
        } else {
          console.log('订单提交失败.')
        }
      })
    },
    commitOrder () {
      this.orderCommit()
    },
    onDialogvisible (val) {
      this.ftpDialogvisible = val
    },
    onServerDialogvisible (val) {
      this.serverDialogvisible = val
    },
    getFtpId (val) {
      this.ftp_id = val
    },
    getServerId (val) {
      this.server_id = val
    },
    onAddressDialogvisible (val) {
      this.addressDialogvisible = val
    },
    getAddressId (val) {
      this.address_id = val
    }
  }
}
</script>

<style lang="less">
.deliveryPopover {
  top: 261px !important;
}
.newpopover[x-placement^="bottom"] {
  margin-top: 12px;
}
.newpopover[x-placement^="bottom"] .popper__arrow::after {
  top: 1px;
  margin-left: -6px;
  border-top-width: 0;
  border-bottom-color: rgb(25, 27, 46);
}
.newpopover[x-placement^="bottom"] .popper__arrow {
  top: -6px;
  left: 50%;
  margin-right: 3px;
  border-top-width: 0;
  border-bottom-color: rgb(25, 27, 46);
}
.newpopover {
  position: absolute;
  background: rgb(25, 27, 46);
  min-width: 130px;
  border-radius: 2px;
  padding: 0px;
  z-index: 2000;
  color: #ffffff;
  line-height: 1.4;
  text-align: justify;
  border: 0px;
  font-size: 14px;
  margin-left: 20px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  word-break: break-all;
}
.popdiv {
  cursor: pointer;
  width: 110px;
  height: 20px;
  padding: 10px;
}
.popdiv:hover {
  background-color: rgb(28, 203, 150);
  width: 110px;
  height: 20px;
  padding: 10px;
}
.popper__arrow {
  left: 85px !important;
}
.rightgo {
  margin-right: 10px;
}
.p-main-content {
  li {
    list-style: none;
  }
  .mtop {
    height: 120px;
    background-color: #614e88;
    margin-bottom: 14px;
    position: relative;
    z-index: 9;
  }
  .main-text {
    width: 1100px;
    margin: 0 auto;
    overflow: hidden;
    min-height: 548px;
    position: relative;
    padding: 0px 3px 0px 3px;
    background-color: none;
    top: -80px;
    z-index: 99;
    border-radius: 20px;
    margin-bottom: -40px;
    text-align: left;
    .text {
      .tablelist {
        a {
          color: #333;
        }
      }
      .title {
        height: 228px;
        border-radius: 20px;
        background-color: #fff;
        box-shadow: #ddd 0px 0px 15px;
        margin-bottom: 10px;
        padding: 20px 30px 30px 40px;
        h1 {
          font-size: 28px;
          font-weight: 600;
          color: #f00802;
          span {
            margin-left: 20px;
            vertical-align: middle;
            font-size: 12px;
            font-weight: 500;
            padding: 5px 10px;
            border-radius: 10px;
            color: #fff;
            background-color: #7577f2;
          }
        }
        .ptext {
          line-height: 60px;
          height: 60px;
          margin-top: 0px;
          color: #545c63;
          span {
            margin-right: 40px;
          }
        }
        hr {
          margin-top: 25px;
          height: 2px;
          border: none;
          background-color: #f0f0f0;
        }
        .tstype {
          float: left;
          vertical-align: middle;
          margin-top: 20px;
          li {
            color: #b0b0b0;
            text-align: center;
            outline: none;
            i {
              display: block;
              height: 20px;
              width: 50px;
              height: 50px;
            }
            i.download {
              background: url("../assets/img/download.png") no-repeat center;
            }
            i.ftp {
              background: url("../assets/img/ftp.jpg") no-repeat center;
            }
            i.lxxz {
              background: url("../assets/img/lxxz.png") no-repeat center;
            }
            font-size: 30px;
            padding: 0px 25px;
            height: 30px;
            float: left;
            line-height: 24px;
            span {
              font-size: 14px;
            }
            .sx {
              margin-top: 20px;
              display: inline-block;
              height: 40px;
              border-left: 1px solid #ccc;
            }
          }
          li.active,
          li:hover {
            color: #ff0000;
            i.download {
              background: url("../assets/img/download_h.jpg") no-repeat center;
            }
            i.ftp {
              background: url("../assets/img/ftp2.png") no-repeat center;
            }
            i.lxxz {
              background: url("../assets/img/lxxz_h.jpg") no-repeat center;
            }
          }
          li:hover {
            opacity: 0.5;
          }
        }
        .tobuy {
          float: right;
          margin-top: 100px;
          span {
            line-height: 38px;
          }
          .tip {
            color: #ff0000;
            overflow: hidden;
            float: right;
            margin-right: 40px;
          }
          .buy {
            padding: 10px 30px;
            border-radius: 20px;
            background-color: #fde7e7;
            margin-left: 20px;
            cursor: pointer;
            a {
              color: #f01414;
            }
          }
          span.active,
          span:hover {
            background-color: #ff0000;
            a {
              color: #fff;
            }
          }
          .active {
            background-color: #ff0000;
            a {
              color: #fff;
            }
          }
        }
      }
      .pages {
        text-align: right;
        padding-top: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/PayDetail.vue